/* global G */
import ui from 'lib/hook/ui/update'
import validate from 'lib/hook/model/validate'
import submit from 'lib/hook/model/submit'
import confirm from 'lib/hook/router/confirm'
import read from 'lib/hook/model/read'
import search from 'app/_shared/hook/appbar/search'
import create from 'app/_shared/hook/appbar/create'
import clear from 'app/_shared/hook/model/clear'
import reset from 'app/_shared/hook/component/reset'
import { begin, confirmation, end } from 'lib/hook/transaction'
import acl from 'lib/hook/acl'
import check from 'app/_shared/hook/check'
import back from 'app/_shared/hook/redirect/back'
import recall from 'app/_shared/hook/component/recall'
import cacheTitle from 'app/_shared/hook/model/cacheTitle'
import updateCache from 'app/_shared/hook/model/updateCache'
import cleanAttribute from 'app/_shared/hook/action/cleanAttribute'
import onlineCheck from 'app/_shared/hook/onlineCheck'
import platform from 'app/_shared/hook/platform'
import multiCreate from 'app/_shared/hook/appbar/multiCreate'
import quickActions from 'app/_shared/hook/appbar/quickActions'
import action, { currentAction } from 'lib/hook/module/action'
import recent from 'app/recent/hook/recent'

const _baseHooks = {
  before: [],
  after: [
    ui,
  ],
}

const _listHooks = {
  before: [
    onlineCheck(),
    platform({
      mobile: multiCreate,
    }),
  ],
  after: [
    ui,
  ],
}

const _contactsHooks = {
  before: [
    onlineCheck(),
    platform({
      mobile: create,
    }),
  ],
  after: [
    ui,
  ],
}

const _serviceitemsHooks = {
  before: [
    onlineCheck(),
    platform({
      mobile: create,
    }),
  ],
  after: [
    ui,
  ],
}

const _submitFavoriteHooks = {
  before: [],
  after: [
    ui,
    check,
    confirmation('favorite', 'success'),
    action('successFavorite'),
  ],
}

const _successFavoriteHooks = {
  before: [],
  after: [
    currentAction,
  ],
}

const _newHooks = {
  before: [
    onlineCheck(),
    reset,
  ],
  after: [
    ui,
    confirm,
  ],
}

const _editHooks = {
  before: [
    onlineCheck(),
    clear,
    reset,
    read,
  ],
  after: [
    ui,
    confirm,
  ],
}

const _detailHooks = {
  before: [
    acl,
    clear,
    read,
    cacheTitle('name'),
    recall,
    recent,
    platform({
      mobile: [quickActions, multiCreate],
    }),
  ],
  after: [
    ui,
  ],
}

const _searchAndCreateHooks = {
  before: [
    platform({
      web: [create, search],
      mobile: [multiCreate],
    }),
    recall,
  ],
  after: [
    ui,
  ],
}

const _submitHooks = {
  before: [
    validate,
  ],
  after: [
    ui, // display any validation errors
    check,
    begin,
    submit,
    updateCache,
    // confirmation('success'),
    back,
    end,
  ],
}

// Its empty as it just shows a dialog box
const _confirmHooks = {
  before: [],
  after: [],
}

const hooks = {
  [G.ACTIONS]: {
    index: _searchAndCreateHooks,
    edit: _editHooks,
    new: _newHooks,
    detail: _detailHooks,
    requests: _listHooks,
    serviceitems: _serviceitemsHooks,
    contacts: _contactsHooks,
    submit: _submitHooks,
    confirm: _confirmHooks,

    submitFavorite: _submitFavoriteHooks,
    successFavorite: _successFavoriteHooks,
  },
}

export default hooks
